import { render, staticRenderFns } from "./ModalPremiacao.vue?vue&type=template&id=f908668e&"
import script from "./ModalPremiacao.vue?vue&type=script&lang=js&"
export * from "./ModalPremiacao.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports